import type from "./type";

export default type("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});



//////////////////
// WEBPACK FOOTER
// ./~/d3-request/src/json.js
// module id = 199
// module chunks = 0 1 2 3 4